import { useRequestURL, useRoute } from '#app'
import { computed } from 'vue'
import {
    layoutModeGroupLink,
    layoutModeKioskLink,
    layoutModeLightboxLink
} from '~/composables/routing'

export function useLayoutMode() {
    const route = useRoute()
    const url = useRequestURL()
    const isPrintMode = computed(
        () => typeof route.query.print === 'string' && route.query.print !== ''
    )
    const printMode = computed(() => route.query.print)
    const isMobileApp = computed(() => {
        if (import.meta.env.DEV) {
            if (url.hostname.toLowerCase().endsWith('-mobile.localhost')) {
                return true
            }
        }

        return url.hostname.toLowerCase().endsWith('-mobile.rphq.com')
    })

    const layoutMode = computed(() => route.params.mode)
    const isLightbox = computed(() => {
        return layoutMode.value === 'lightbox' || route.name === 'lightbox'
    })
    const kioskSlug = computed(() => {
        return typeof layoutMode.value === 'string' &&
            layoutMode.value.startsWith('kiosk-')
            ? layoutMode.value.substring(6)
            : null
    })
    const isKiosk = computed(() => kioskSlug.value !== null)

    const groupBookingId = computed(() => {
        return typeof layoutMode.value === 'string' &&
            layoutMode.value.startsWith('group-')
            ? layoutMode.value.substring(6)
            : null
    })
    const isGroup = computed(() => groupBookingId.value !== null)

    function preserveModeLink(url: string) {
        if (isLightbox.value) {
            return layoutModeLightboxLink(url)
        }

        if (kioskSlug.value) {
            return layoutModeKioskLink(kioskSlug.value, url)
        }

        if (groupBookingId.value) {
            return layoutModeGroupLink(groupBookingId.value, url)
        }

        return url
    }

    return {
        isPrintMode,
        printMode,
        isMobileApp,
        layoutMode,
        isLightbox,
        isKiosk,
        kioskSlug,
        isGroup,
        groupBookingId,
        preserveModeLink
    }
}
